import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Cities = lazy(() => import("@/pages/Cities"));

export const Route = createFileRoute("/cities/")({
  head: () => pageHead({ path: "/cities", title: "Amorette Markets | Where Curated Social Dining Is Launching", description: "Explore the cities where Amorette curated social dining is hosting or launching soon, and join your city's waitlist.", canonical: false }),
  component: Cities,
});
